/* global Swiper */
// **********************************************************
// Gallery slider
// **********************************************************

const gallerySliderElements = document.querySelectorAll('[data-slider="gallery-popup-slider"]');
const gallerySliderOptions = {
  slidesPerView: 1,
  spaceBetween: 0,
  watchOverflow: true,
  pagination: {
    el: '.swiper-pagination',
    type: 'fraction',
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  effect: 'fade',
  fadeEffect: {
    crossFade: true,
  },
  keyboard: {
    enabled: true,
  },
};

gallerySliderElements.forEach((el) => {
  const gallerySliderParent = el.closest('.gallery-popup');
  const gallerySliderPagination = gallerySliderParent.querySelector('.swiper-pagination');
  const arrowRight = gallerySliderParent.querySelector('.arrow-right');
  const arrowLeft = gallerySliderParent.querySelector('.arrow-left');
  gallerySliderOptions.navigation.nextEl = arrowRight;
  gallerySliderOptions.navigation.prevEl = arrowLeft;
  gallerySliderOptions.pagination.el = gallerySliderPagination;
  // eslint-disable-next-line no-new
  new Swiper(el, gallerySliderOptions);
});

// **********************************************************
// Gallery popup
// **********************************************************

// Close gallery popup
document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape' && gallerySliderElements.length) {
    document.querySelectorAll('.gallery-popup.is-open-modal').forEach((el) => {
      el.classList.remove('is-open-modal');
      document.body.classList.remove('is-open-modal');
    });
  }
});
